import React from 'react';
import { TypeIcon } from 'lucide-react';
import { CreativeDirectoryPage, CreativeArtist } from '../../components/creative/CreativeDirectoryPage';
const artists: CreativeArtist[] = [{
  id: '1',
  name: 'Lisa Park',
  title: 'Book Typographer',
  specialties: ['Custom Typography', 'Font Design', 'Layout Typography'],
  rating: 4.9,
  reviewCount: 76,
  imageUrl: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
  available: true,
  priceRange: '$300-800'
}, {
  id: '2',
  name: 'David Morgan',
  title: 'Typography Specialist',
  specialties: ['Book Design', 'Title Typography', 'Hand Lettering'],
  rating: 4.8,
  reviewCount: 58,
  imageUrl: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
  available: true,
  priceRange: '$250-700'
}];
const Typographers = () => <CreativeDirectoryPage title="Typographers" subtitle="Connect with expert typographers to create beautiful and readable book layouts and custom typography" icon={<TypeIcon className="h-8 w-8" data-id="element-8631" data-mp="1yelv03dyi4q7" />} profileBasePath="/creative/typographers" artists={artists} data-id="element-8630" data-mp="1ylq71prpygy8" />;
export default Typographers;